const Theme = {
  card_background_color: 'white',
  body_background_color: '#BEBEBF',

  logo_image_url: 'aventuria2.png',
  logo_height:120,

  token_url: 'aventuria.png',
  number_hidden: true,

  button_color: '#95c11f',

  text_font: 'Montserrat',
  text_color: 'black',

  title_font: 'Gotham',
  title_weight: 400,
  subtitle_font: 'Gotham',

  popup_text_color: 'black',

  button_radius: 25,
  button_no_border: true,
}

export default Theme
